import { render, staticRenderFns } from "./SnagCard.vue?vue&type=template&id=7866a2a4&scoped=true"
import script from "./SnagCard.vue?vue&type=script&lang=js"
export * from "./SnagCard.vue?vue&type=script&lang=js"
import style0 from "./SnagCard.vue?vue&type=style&index=0&id=7866a2a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7866a2a4",
  null
  
)

export default component.exports